(() => {
  const updateOffset=()=>{
    const header=document.querySelector('.shopify-section--header');
    const announcement=document.querySelector('.AnnouncementBar');
    const height=(header?.getBoundingClientRect().height||0)+(announcement?.getBoundingClientRect().height||0)+18;
    document.documentElement.style.setProperty('--lf-header-offset',`${height}px`);
  };
  document.addEventListener('DOMContentLoaded',updateOffset);
  window.addEventListener('resize',updateOffset,{passive:true});
  document.addEventListener('shopify:section:load',updateOffset);
  if(document.readyState!=='loading')updateOffset();
  const connectCollectionTabs=()=>{
    document.querySelectorAll('[data-section-type="featured-collections"] [role="tablist"]').forEach(list=>{
      if(list.dataset.loufordTabsReady)return;
      list.dataset.loufordTabsReady='true';
      const tabs=[...list.querySelectorAll('[role="tab"]')];
      const sync=()=>tabs.forEach(tab=>{
        const selected=tab.classList.contains('is-active');
        tab.setAttribute('aria-selected',String(selected));
        tab.tabIndex=selected?0:-1;
      });
      sync();
      new MutationObserver(sync).observe(list,{attributes:true,attributeFilter:['class'],subtree:true});
      list.addEventListener('keydown',event=>{
        const index=tabs.indexOf(event.target);
        if(index<0)return;
        let next;
        if(event.key==='ArrowRight')next=(index+1)%tabs.length;
        else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=tabs.length-1;
        else return;
        event.preventDefault();
        tabs[next].click();
        tabs[next].focus();
      });
    });
  };
  document.addEventListener('DOMContentLoaded',connectCollectionTabs);
  document.addEventListener('shopify:section:load',connectCollectionTabs);
  if(document.readyState!=='loading')connectCollectionTabs();
})();

(() => {
  const connectSearch = () => {
    const modal = document.querySelector('#Search[data-louford-all-products]');
    if (!modal || modal.dataset.loufordSearchReady) return;
    const input = modal.querySelector('[name="q"]');
    const results = modal.querySelector('.Search__Results');
    const form = input?.form;
    if (!input || !results || !form) return;
    modal.dataset.loufordSearchReady = 'true';
    const searchUrl = new URL(modal.dataset.searchUrl || form.action, window.location.href);
    const loadedPages = new Set();
    let revision = 0;
    let debounce;
    let request;
    let observer;
    let next;
    let query = '';
    let loading = false;
    let composing = false;

    const buildUrl = (raw, ajax = true) => {
      const url = new URL(raw || searchUrl.href, searchUrl.href);
      if (url.origin !== searchUrl.origin) throw new Error('Invalid search URL');
      url.pathname = searchUrl.pathname;
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      if (ajax) url.searchParams.set('view', 'ajax');
      else url.searchParams.delete('view');
      return url.href;
    };
    const refreshImages = () => window.lazySizes?.loader?.checkElems?.();
    const watchNext = () => {
      observer?.disconnect();
      observer = null;
      next = results.querySelector('[data-louford-search-next]');
      if (!next) return;
      if (loadedPages.has(buildUrl(next.dataset.nextUrl || next.href))) {
        next.remove();
        next = null;
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && modal.getAttribute('aria-hidden') === 'false') loadMore();
      }, { root: modal, rootMargin: '200px' });
      observer.observe(next);
    };
    const load = async (url, append, version, focusAdded = false) => {
      if (loading || version !== revision) return;
      loading = true;
      observer?.disconnect();
      const controller = new AbortController();
      request = controller;
      results.setAttribute('aria-busy', 'true');
      next?.setAttribute('aria-disabled', 'true');
      try {
        const response = await fetch(url, { method: 'GET', credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Search request failed');
        const html = await response.text();
        if (version !== revision || controller.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const segment = parsed.querySelector('[data-louford-search-products]');
        if (!segment || segment.dataset.searchQuery !== query) throw new Error('Unexpected search response');
        let firstAdded;
        if (append) {
          const grid = results.querySelector('[data-louford-search-grid]');
          const incomingGrid = segment.querySelector('[data-louford-search-grid]');
          if (!grid || !incomingGrid || !incomingGrid.children.length) throw new Error('Empty search page');
          const cells = [...incomingGrid.children].map(cell => document.importNode(cell, true));
          firstAdded = cells[0].querySelector('a');
          grid.append(...cells);
          next?.remove();
          const incomingNext = segment.querySelector('[data-louford-search-next]');
          if (incomingNext) (grid.closest('.Segment__Content') || grid.parentElement).append(document.importNode(incomingNext, true));
        } else {
          results.replaceChildren(document.importNode(segment, true));
        }
        loadedPages.add(url);
        refreshImages();
        if (focusAdded) firstAdded?.focus({ preventScroll: true });
        watchNext();
      } catch (error) {
        if (version !== revision || controller.signal.aborted) return;
        observer?.disconnect();
        if (!append) {
          const fallback = document.createElement('a');
          fallback.className = 'LoufordSearch__More';
          fallback.href = buildUrl(null, false);
          fallback.textContent = results.dataset.searchFallbackLabel || form.querySelector('[type="submit"]').textContent;
          results.replaceChildren(fallback);
        }
      } finally {
        if (version === revision && request === controller) {
          request = null;
          loading = false;
          results.setAttribute('aria-busy', 'false');
          next?.removeAttribute('aria-disabled');
        }
      }
    };
    const loadMore = (focusAdded = false) => {
      if (!next || loading) return;
      const url = buildUrl(next.dataset.nextUrl || next.href);
      if (!loadedPages.has(url)) load(url, true, revision, focusAdded);
    };
    const onInput = () => {
      clearTimeout(debounce);
      revision += 1;
      request?.abort();
      request = null;
      observer?.disconnect();
      observer = null;
      next = null;
      loading = false;
      loadedPages.clear();
      results.replaceChildren();
      results.setAttribute('aria-busy', 'false');
      const term = input.value.trim();
      query = term ? `${term}*` : '';
      if (!query || composing) return;
      const version = revision;
      debounce = setTimeout(() => load(buildUrl(), false, version), 250);
    };
    input.addEventListener('input', onInput);
    input.addEventListener('compositionstart', () => { composing = true; });
    input.addEventListener('compositionend', () => { composing = false; onInput(); });
    input.addEventListener('keyup', event => {
      if (event.key === 'Escape' || event.keyCode === 27) modal.querySelector('.Search__Close[data-action="close-modal"]')?.click();
      event.stopImmediatePropagation();
    }, true);
    results.addEventListener('click', event => {
      const link = event.target.closest('[data-louford-search-next]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadMore(true);
    });
    if (input.value.trim()) onInput();
  };
  document.addEventListener('DOMContentLoaded', connectSearch);
  if (document.readyState !== 'loading') connectSearch();
})();
